import Http from "../../service/api";
import { judgeIsSplice } from "../../common/utils";

// -----------------------------  题库管理  -------------------------
// 获取题库中难度数目 已调用
export async function batchQuestion(params: any) {
  return Http.post(`/api/v1/exam/batchQuestion${judgeIsSplice(true)}`, params);
}
// 表单创建题目 已调用
export async function createQuestion(params: any) {
  return Http.post(`/api/v1/exam/createQuestion${judgeIsSplice(true)}`, params);
}
// 获得题库列表（平级） 需要去转出树状 按parentID 已调用
export async function getExamAllPool(params: any) {
  return Http.get(`/api/v1/exam/allPool${judgeIsSplice()}`, params);
}
// 创建题库 已调用
export async function createPool(params: any) {
  return Http.post(`/api/v1/exam/createPool${judgeIsSplice(true)}`, params);
}
// 修改题库 已调用
export async function modifyPool(params: any) {
  return Http.put(`/api/v1/exam/modifyPool${judgeIsSplice()}`, params);
}
// 删除题库 已调用
export async function removePool(params: any) {
  return Http.deletes(`/api/v1/exam/removePool${judgeIsSplice()}`, params);
}
// 分页获取题目（包括检索） 已调用
export async function getAllQuestion(params: any) {
  return Http.get(`/api/v1/exam/allQuestion${judgeIsSplice()}`, params);
}
// 删除试题 已调用
export async function removeQuestion(params: any) {
  return Http.post(`/api/v1/exam/removeQuestion${judgeIsSplice()}`, params);
}
// 获取题库中难度数目 已调用
export async function getCountList(params: any) {
  return Http.post(`/api/v1/exam/getCount${judgeIsSplice()}`, params);
}
// 根据id获取题目 已调用
export async function getQuestionInfo(params: any) {
  return Http.get(`/api/v1/exam/getQuestion${judgeIsSplice()}`, params);
}
// 修改题目信息 已调用
export async function modifyQuestion(params: any) {
  return Http.put(`/api/v1/exam/modifyQuestion${judgeIsSplice(true)}`, params);
}
// 移动试题 已调用
export async function moveQuestion(params: any) {
  return Http.put(`/api/v1/exam/move${judgeIsSplice()}`, params);
}

// 给题目排序
export async function orderQuestion(params: any) {
  return Http.put(`/api/v1/exam/modifyQuestion${judgeIsSplice(true)}`, params);
}

// -----------------------------  考试管理  -------------------------
// 获取考试列表（管理端）
export async function getExamList(params: any) {
  return Http.get(`/api/v1/exam/listExam${judgeIsSplice()}`, params);
}
// 获取考试模板列表 已调用
export async function getExamTempList(params: any) {
  return Http.get(`/api/v1/exam/listExamTemp${judgeIsSplice()}`, params);
}
// 创建考试模版 已调用
export async function createExamTemp(params: any) {
  return Http.post(`/api/v1/exam/createExamTemp${judgeIsSplice()}`, params);
}
// 修改考试模版 已调用
export async function updateExamTemp(params: any) {
  return Http.post(`/api/v1/exam/updateExamTemp${judgeIsSplice()}`, params);
}
// 删除考试模版  已调用
export async function delExamTemp({ id }: { id: string }) {
  return Http.deletes(`/api/v1/exam/delExamTemp/${id}${judgeIsSplice()}`, {});
}
// 获取考试模板详细信息
export async function getExamTempDetail(params: any) {
  return Http.get(`/api/v1/exam/getTempDetail${judgeIsSplice()}`, params);
}
// 通过模板创建考试
export async function createExamByTemp(params: any) {
  return Http.post(`/api/v1/exam/createExamByTemp${judgeIsSplice(true)}`, params);
}
// 创建考试 已调用
export async function createExam(params: any) {
  return Http.post(`/api/v1/exam/createExam${judgeIsSplice()}`, params);
}
// 更新考试 已调用
export async function updateExam(params: any) {
  return Http.post(`/api/v1/exam/updateExam${judgeIsSplice()}`, params);
}
// 删除考试 已调用
export async function delExam({ id }: { id: string }) {
  return Http.deletes(`/api/v1/exam/delExam/${id}${judgeIsSplice()}`, {});
}

// 修改考试状态
export async function updateExamStatus(params: any) {
  return Http.post(`/api/v1/exam/updateExamStatus${judgeIsSplice()}`, params);
}


// 获取考试详细信息
export async function getExamDetail(params: any) {
  return Http.get(`/api/v1/exam/getDetail${judgeIsSplice()}`, params);
}
// 上机考试申请
export async function submitExamAuto(params: any) {
  return Http.post(`/api/v1/exam/autoSubmit${judgeIsSplice()}`, params);
}

// -----------------------------  试卷库  -------------------------
// 获取试卷
export async function getPaperList(params: any) {
  return Http.get(`/api/v1/exam/getPaper${judgeIsSplice()}`, params);
}
// 获取考试记录列表
export async function getListRecord(params: any) {
  return Http.get(`/api/v1/exam/listRecord${judgeIsSplice()}`, params);
}
// 获取考试记录详情
export async function getRecordInfo(params: any) {
  return Http.get(`/api/v1/exam/getRecord${judgeIsSplice()}`, params);
}
// 删除考试记录
export async function delRecord({ id }: { id: string }) {
  return Http.deletes(`/api/v1/exam/delRecord/${id}${judgeIsSplice()}`, {});
}
// -----------------------------  人员  -------------------------
// 获取人员信息
export async function getUserInfo(params: any) {
  return Http.get(`/api/v1/exam/getUser${judgeIsSplice()}`, params);
}
// 人员列表
export async function getExamUsers(params: any) {
  return Http.get(`/api/v1/exam/searchUsers${judgeIsSplice()}`, params);
}
// 下载人员模板文件
export async function downloadUserTemplate(params: any) {
  return Http.get(`/api/v1/exam/downloadUserTemplate${judgeIsSplice()}`, params);
}
// 查询人员是否存在
export async function searchUsersInBatch(params: any) {
  return Http.post(`/api/v1/exam/searchUsersInBatch${judgeIsSplice()}`, params);
}
// -----------------------------  证书  -------------------------
// 证书模版列表
export async function getCerTemplateList(params: any) {
  return Http.get(`/api/v1/exam/certTemplateList${judgeIsSplice()}`, params);
}
// 绑定考试证书信息
export async function bindingExamCert(params: any) {
  return Http.post(`/api/v1/exam/bindingExamCert${judgeIsSplice()}`, params);
}
// 解绑考试证书信息
export async function unbindingExamCert(params: any) {
  return Http.deletes(`/api/v1/exam/unbindingExamCert${judgeIsSplice()}`, params);
}
// 制作证书
export async function makeCertificate(params: any) {
  return Http.post(`/api/v1/exam/makeCertificate${judgeIsSplice()}`, params);
}
// 根据证书模板id查询
export async function getCertTemplate(params: any) {
  return Http.get(`/api/v1/exam/getCertTemplate${judgeIsSplice()}`, params);
}
// 根据证书id查询
export async function getCertInfo(params: any) {
  return Http.get(`/api/v1/exam/getCertInfo${judgeIsSplice()}`, params);
}
// 证书列表
export async function getCertList(params: any) {
  return Http.get(`/api/v1/exam/certList${judgeIsSplice()}`, params);
}
// getCertByUserName
export async function getCertListByUserName(params: any) {
  return Http.get(`/api/v1/exam/getCertByUserName${judgeIsSplice()}`, params);
}
// 检查考试资格
export async function checkExam(params: any) {
  return Http.get(`/api/v1/exam/check${judgeIsSplice()}`, params);
}



// 获取考试环境反馈列表
export async function getFeedbackList(params: any) {
  return Http.get(`/api/v1/exam/feedback/list${judgeIsSplice()}`, params);
}


// 获取考试评价列表
export async function getEvaluateList(params: any) {
  return Http.get(`/api/v1/exam/evaluate/list${judgeIsSplice()}`, params);
}


// 获取考试评价列表
export async function getNoticeList(params: any) {
  return Http.get(`/api/v1/exam/notice/list${judgeIsSplice()}`, params);
}
